import { CompanyPaymentsMessages } from "@/messages/customer/company-payments.messages";

type ColumnAlign = "left" | "center" | "right";

export type PaymentTableColumn = {
  label: string;
  align: ColumnAlign;
};

export const PAYMENTS_TABLE_COLUMNS = (messages: CompanyPaymentsMessages): PaymentTableColumn[] => [
  { label: messages.productColumn, align: "left" },
  { label: messages.planColumn, align: "left" },
  { label: messages.statusColumn, align: "center" },
  { label: messages.dueDateColumn, align: "center" },
  { label: messages.valueColumn, align: "right" },
  { label: messages.paymentColumn, align: "center" },
];

export const defaultPageNumber = 1;
export const defaultPageSize = 50;
